<template>
<div>
  <div>
    <div class="box" v-bind:style="background">
      <div class="container title-container">
        <div class="row">
          <span class="top-title-box">
            <div class="top-background">
              <h1 class="top-title">BUS</h1>
              <h2 class="top-subtitle">東栄観光バス</h2>
            </div>
          </span>
          <span class="message-background">
            <h2 class="message">
             <p><span>いつもの場所と</span></p>
             <p><span>旅先をつなぐ、</span></p>
             <p><span>カラフルなプードルバス</span></p>
            </h2>
          </span>
          <span>
            <div class="top-icon">
              <div class="icon-1">
                <img src="@/assets/bus-icon-1.png"/>
              </div>
              <div class="icon-2">
                <img src="@/assets/bus-icon-2.png"/>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="headline">
      <img src="@/assets/favicon.png"/>
        東栄観光バスの特徴
      </div>
      <div class="features">
        <img class="background" src="@/assets/bus-1.jpg"/>
        <div class="color">
          <div class="col-xs-12 col-lg-6 color-resizeimage">
            <img src="@/assets/bus-content.png"/>
          </div>
          <div class="col-xs-12 col-lg-6 order-md-first resizeimage disc">
            <div class="color-table-container">
              <div class="color-table-title">
                <div class="color-table-caption">
                  COLOR
                </div>
                旅をもっとワクワクさせる、<br>カラフルな”プードルバス<sup>&reg;</sup>”
              </div>
              <table class="color-table">
                <tbody>
                  <tr>
                    <td class="text">私たちがご提供する車両は、鮮やかなトリコロールカラー<br class="newline">の車体に、色違いのプードルマークが描かれています。<br>皆さまそれぞれの旅を、それぞれのカラーでお迎えします。</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="features-topic">
          <div class="topic-1">
            <div class="topic-img">
              <img src="@/assets/bus-icon-3.png">
            </div>
            <div class="topic">
              <div class="topic-title">
              最新型のバスを導入
              </div>
              <div class="topic-content">
              安全性・乗り心地にこだわった、業界最新水準のバスを導入しています。
              </div>
            </div>
          </div>
          <div class="topic-1">
            <div class="topic-img">
              <img src="@/assets/bus-icon-4.png">
            </div>
            <div class="topic">
              <div class="topic-title">
              最高評価を獲得
              </div>
              <div class="topic-content">
              「貸切バス安全性評価」<br>最高ランク★★★を業界最長年数<br>獲得し続けています。
              </div>
            </div>
          </div>
          <div class="topic-1">
            <div class="topic-img">
              <img src="@/assets/bus-icon-5.png">
            </div>
            <div class="topic">
              <div class="topic-title">
              経験豊富なスタッフが運行
              </div>
              <div class="topic-content">
              専門教育を受けたドライバー・ガイド（アシスタントレディ）が丁寧・快適な旅をご提供します。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="headline">
        <img src="@/assets/favicon.png"/>
          車両詳細
      </div>
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/bus-content-1.jpg"/>
          <div class="disc-caption">
            <a>49人乗（補助席込53人乗）中二階タイプ</a>
          </div>
        </div>
        <div class="col-xs-12 col-lg-5 order-md-first disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                車両紹介
              </div>
              21人乗りから60人乗りまで。
              景色の良いスーパーハイデッカーを中心に大小さまざまな車種をラインナップ。
            </div>
            <table class="table type-table">
              <tbody>
                <tr>
                  <th>49人<a>乗</a></th>
                  <td>｜補助席込60人乗
                  ｜補助席込50人乗スーパーハイデッカー
                  </td>
                </tr>
                <tr>
                  <th class="no-border">45人<a>乗</a></th>
                  <td class="no-border">｜補助席込53人乗
                    ｜補助席込52人乗スーパーハイデッカー
                  </td>
                </tr>
                <tr>
                  <th class="no-border">33人<a>乗</a></th>
                  <td class="no-border">｜補助席込39人乗</td>
                </tr>
                <tr>
                  <th class="no-border">27人<a>乗</a></th>
                  <td class="no-border">｜補助席なし</td>
                </tr>
                <tr>
                  <th class="no-border">21人<a>乗</a></th>
                  <td class="no-border">｜補助席込27人乗マイクロバス</td>
                </tr>
              </tbody>
            </table>
            <a href="https://toei.myweb.co.jp/bus/pamphlet.pdf" class="box4">
              <p>パンフレットPDFのダウンロード</p>
              <div class="arrow01"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/bus-content-6.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                車両設備
              </div>
              安全装備も業界最高水準。
              どんな道でも安心して
              お乗りいただけます。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">
                    <li>車間クルーズ機能</li>
                    <li>衝突被害軽減ブレーキ（PCS）</li>
                    <li>衝突後制動機能</li>
                    <li>衝突回避支援機能</li>
                    <li>ドライバーモニター</li>
                    <li>車線逸脱警報装置</li>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="disc-caption">
            <a>※車両設備は車種ごとに異なります。</a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/bus-content-9.jpg"/>
        </div>
        <div class="col-xs-12 col-lg-5 order-md-first resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                安全の取り組み
              </div>
              最高ランクの安全性評価を業界最長の15年連続で獲得。
              現在業界最高ランクの★★★★です。
              私たちは日々、安全を追求しています。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">
                    安全性を高めるためにあらゆる面から取り組みを行っています。
                    <router-link class="box4" to="/safety">
                      <p>当社の安全への取り組み</p>
                      <div class="arrow01"></div>
                    </router-link>
                    安全への取り組みが評価され、国土交通省の講演会で発表を行いました。
                    <a href="https://www.nasva.go.jp/gaiyou/pdf/2016/20161102_1.pdf" target="_blank" class="box4">
                      <p>国土交通省での講演会</p>
                      <div class="arrow01"></div>
                    </a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/bus-content-7.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                車内設備
              </div>
              それぞれの旅にあった、
              それぞれの設備をお楽しみください。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">
                  <li>テレビモニター</li>
                  <li>CD/DVDデッキ</li>
                  <li>カラオケ</li>
                  <li>冷蔵庫</li>
                  <li>湯沸設備</li>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="disc-caption">
            <a>※車内設備のご利用希望の際は、予約時にお申し付けください。</a>
          </div>
        </div>
      </div>
    </div>
    <div class="corona-headline">
        <img src="@/assets/favicon.png"/>
          感染症対策について
    </div>
    <div class="container-fluid corona">
      <div class="corona-message">
        <div class="title-box">
          <h1 class="corona-title">感染症対策も、<br>業界でいち早く導入しました。</h1>
        </div>
      </div>
    </div>
    <div class="container-fluid measures">
      <div class="row">
        <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
          <img src="@/assets/01_エアコン@2x.png"/>
          <div class="box">
            <p>車内の空気を5分で総入れ替え<br>エアコン外気導入モード</p>
          </div>
        </div>
        <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
          <img src="@/assets/02_乗務員@2x.png"/>
          <div class="box">
            <p>運転士・アシスタントレディ<br>マスク着用</p>
          </div>
        </div>
        <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
          <img src="@/assets/05_アルコール@2x.png"/>
          <div class="box">
            <p>アルコール除菌液の設置</p>
          </div>
        </div>
        <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
          <img src="@/assets/06_車内アルコール@2x.png"/>
          <div class="box">
            <p>運行前後や必要なタイミングでの<br>車内アルコール消毒の徹底</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="headline">
        <img src="@/assets/favicon.png"/>
          ご利用シーン
      </div>
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/bus-content-4.jpg"/>
        </div>
        <div class="col-xs-12 col-lg-5 order-md-first resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                事業例
              </div>
              少人数から大人数まで様々な
              ご旅行でご利用いただけます。
              現地までゆったりとした旅を
              お楽しみください。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">
                  <li>修学旅行や遠足などの学校行事</li>
                  <li>町内会主催のご旅行</li>
                  <li>部活動やクラブチームの合宿</li>
                  <li>旅行会社の募集型企画旅行</li>
                  <li>企業の研修</li>
                  <li>同窓会</li>
                  など
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="link">
      <a href="https://wwwtb.mlit.go.jp/kanto/content/000227543.pdf" target="_blank" class="box6">
                      <p>運送約款</p>
                    </a>
      <a href="/static/bus_unchinryokin_251101.pdf" target="_blank" class="box6">
                      <p>運賃料金表</p>
                    </a>
    </div>
    <div class="container contact-container">
      <div class="caption">
        貸切バスのお見積り
      </div>
      <div class="row contact-box">
        <div class="col-xs-12 col-lg-6">
          <h1>ご相談先</h1>
          <p>お電話にてお問い合わせ下さい</p>
        </div>
        <div class="col-xs-12 col-lg-6">
          <p class="tel"><a href="tel:03-3965-0556">03-3965-0556</a></p>
        </div>
      </div>
      <div class="office-box">
        <div class="col-xs-12 col-lg-6 contact">
          <span>東京営業所</span>
          〒174-0051<br>東京都板橋区小豆沢2-3-11
          T:03-3965-0556｜F:03-3965-0557
        </div>
        <div class="col-xs-12 col-lg-6 contact">
          <span>横浜営業所</span>
          〒223-0057<br>神奈川県横浜市港北区新羽町1187
          T:045-540-2710｜F:045-531-8965
        </div>
        <div class="col-xs-12 col-lg-6 contact">
          <span>さいたま第二営業所</span>
          〒339-0011<br>埼玉県さいたま市岩槻区長宮94
          T:048-799-1214｜F:048-799-1088
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
  components: {
    Title
  },
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'BUS',
      message: '1台ごとに色の異なる、カラフルなプードルバス'
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/bus-top.jpg') + "') no-repeat 40% 95%"
  }
}
</script>

<style scoped>
.message-background {
  writing-mode: vertical-rl;
  background: 0% 0% no-repeat padding-box;
  padding: 7px 14.5px;
  position: absolute;
  bottom: 120px;
  margin: 20px;
  right: 0px;
  letter-spacing: 3px;
}
.top-background {
  width: 13.5%;
  height: 22%;
  position: absolute;
  top: 65px;
  left: 105px;
}
.top-title {
  font-size: 76px;
  letter-spacing: 0;
  border-bottom: solid;
  color: #FFF;
  opacity: 1;
  position: absolute;
  top: -5px;
  left: -50px;
  width: 175px;
  text-align: center;
  letter-spacing: 2px;
}
.top-subtitle {
  font-size: 28px;
  letter-spacing: 0;
  color: #FFF;
  opacity: 1;
  position: absolute;
  top: 95px;
  left: -50px;
  width: 175px;
  letter-spacing: 1px;
}
.top-icon{
  position: absolute;
  bottom: 30px;
  display:flex;
  flex-flow: column;
  left: 50px;
}
.headline {
  font-size: 36px;
  margin-bottom: 20px;
}
.corona-headline {
  font-size: 36px;
  padding: 5% 5% 2% 5%;
}
.content {
  padding-top: 5%;
  max-width: 1280px;
}
.content .row {
  align-items: center;
}
.features {
  margin: 145px -50px 0 -50px;
  padding-top: 145px;
  position: relative;
}
.features img {
  width: 100%;
}
.background {
  background-color: #2e2e2e;
  opacity: 0.7;
  height: 800px;
  object-fit: cover;
  object-position:50% 8%;
}
.color {
  display: flex;
  align-items: center;
  padding: 4%;
  margin: 2%;
  position: absolute;
  top: -160px;
  background-color: #000;
  width: 96%;
}
.color-resizeimage {
  width: 100%;
  text-align: center;
}
.color-resizeimage img {
  width: 70%;
}
.color .disc {
  margin-left: 50px;
}
.color-table-title {
  color: #FFF;
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 20px;
  position: relative;
}
.color-table-caption {
  position: absolute;
  top: -45%;
  font-size: 16px;
  color: #FFF;
  font-weight: normal;
}
.color-table {
  color: #FFF;
  font-size: 16px;
  font-weight: normal;
  border-top: solid 1px #FFF;
  margin: 0 calc(50% - 30vw);
  width: 50vw;
}
.color-table td {
  vertical-align: middle;
  padding: 12px 12px 12px 110px;
}
.color-table .text {
  font-size: 20px;
  text-align: left;
}
.newline{
  display:block
}
.features-topic {
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 2% 4% 4% 4%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
.features-topic img {
  max-width: 148px;
}
.topic-1 {
  margin: 0 auto;
  padding: 30px 14px 7px 14px;
  font-size: 14px;
  color: #3B4043;
  width: 310px;
  height: 310px;
  background-color: #FFF;
  text-align: center;
}
.topic-img{
  text-align: center;
}
.topic {
  padding-top: 20px;
}
.topic-title {
  border-bottom: solid;
  border-width: 1px;
  padding: 3%;
  font-size: 18px;
}
.topic-content {
  padding: 3%;
}
.content {
  padding-top: 5%;
  max-width: 1280px;
}
.content .row {
  align-items: center;
}
.table-container {
  padding: 2% 4% 4% 4%;
  white-space: pre-line;
}
.table-container.last {
  padding-bottom: 40px;
}
.table td {
  color: #000000;
  vertical-align: middle;
}
.table th {
  font-size: 34px;
  color: #000000;
  vertical-align: middle;
}
@media screen and (max-width: 1280px) {
  .type-table td {
    color: #000000;
    vertical-align: middle;
    font-size: 12px;
    padding-left: 0;
    padding-right: 0;
  }
  .type-table th {
    padding-left: 7px;
    padding-right: 0;
    font-size: 24px;
    color: #000000;
    width: 26%;
    vertical-align: middle;
  }
}
.table a{
  font-size: 16px;
}
.table .no-border {
  border-top: none;
}
.text {
  font-size: 16px;
}
.text li {
  list-style: inside;
}
.table-title {
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 20px;
  position: relative;
}
.table-caption {
  position: absolute;
  top: -16%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
.box4 {
  border: 2px solid #7E7474;
  padding: 5px 14px;
  margin-top: 10px;
  margin-bottom: 11px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box4 p {
  font-size: 20px!important;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.arrow01 {
  display: block;
  width: 12px;
  height: 12px;
  border-top: solid 3px #7E7474;
  border-right: solid 3px #7E7474;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: 13%;
}
.link {
  padding: 2% 4% 4% 4%;
  display: flex;
}
.box6 {
  border:2px solid #a6a6a6;
  padding:5px 14px;
  background:#FFF 0% 0% no-repeat padding-box;
  right:9px;
  bottom:27px;
  width:500px;
  min-width:170px;
  display:flex;
  justify-content:center;
  align-items:center;
  margin:0 auto;
}
.box6 p {
  font-size: 20px;
  font-weight: 600;
  color: #000;
  margin: 0;
  padding: 0;
}
.caption {
  position: absolute;
  top: 0%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
.resizeimage {
  padding-right: 0px;
  padding-left: 0px;
  text-align: end;
  min-width: 240px;
}
.resizeimage img {
  width: 100%;
}
.resizeimage a {
  font-size: 10px;
  padding-right: 2%;
}
.disc {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: left;
}
.disc-caption {
  text-align: end;
}
.corona-message {
  position: relative;
}
.corona-message .title-box {
  position: absolute;
  top: 229px;
  left: 50%;
  padding: 0;
  display: block;
  text-align: center;
}
.corona-title {
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0;
  color: #3B4043;
  line-height: 55px;
  text-align: center;
}
.title-box h2 {
  font-size: 16px;
  text-align: center;
  font-weight: bold;
}
.title-box {
  display: inline-flex;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 60px;
}
.corona {
  background: url("../assets/top-bus-corona.png");
  background-color: #FFF0F9;
  background-repeat: no-repeat;
  background-size: 63%;
  background-position: left;
  min-height: 414px;
}
.measures {
  padding: 60px;
  background-color: #EBF3FF;
  margin-top: 30px;
}
.measures img {
  max-width: 148px;
}
.measures .icon {
  text-align: center;
}
.measures .box {
  padding: 7px 14px;
  text-align: center;
  font-size: 14px;
  color: #3B4043;
}
.contact-container {
  padding-top: 40px;
  padding-bottom: 40px;
  white-space: pre-line;
  position: relative;
}
.contact-box {
  border: 2px solid #7E7474;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 75px 20px 75px 20px;
  margin-top: 20px;
  margin-bottom: 11px;
  margin-left: 0px;
  margin-right: 0px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  text-align: center;
}
.contact-box h1 {
  color: #000;
  font-size: 48px;
}
.contact-box p {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.contact-box p.tel {
  font-size: 36px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.tel a {
  color: #000;
}
.office-box {
  padding: 0px 0px;
  display: flex;
  width: 67%;
}
@media screen and (max-width: 480px) {
  .top-background {
  width: 48%;
  height: 15%;
  left: 20px;
  }
  .top-title {
    left: 10px;
    font-size: 68px;
    top: -20px;
  }
  .top-subtitle {
    left: 15px;
    top: 65px;
    font-size: 26px;
  }
  .message-background {
    right: -35px;
    top: 75px;
  }
  .message p {
    margin: 15px 5px;
  }
  .top-icon{
    bottom: 20px;
    right: 10px;
    width: 60%;
    left: 150px;
    text-align: right;
  }
  .icon-1 img {
    width: 65%;
    height: 50%;
  }
  .icon-2 img {
    width: 95%;
    height: 50%;
  }
  .office-box {
    padding: 0px 0px 0px 0px;
  }
  .contact {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 16px;
  }
  .contact span {
    font-size: 17px;
  }
  .resizeimage {
    padding-right: 5%;
    padding-left: 5%;
  }
  .table-title {
    font-size: 22px;
  }
  .headline {
    font-size: 26px;
  }
  .headline img {
    width: 45px;
  }
  .corona-headline {
    font-size: 26px;
  }
  .features {
    margin: 200px 0 25px 0;
    padding: 250px 0 0 0;
    width: 100vw;
    right: 15px;
  }
  .background {
    height: 100%;
  }
  .color {
    display: block;
    top: -190px;
    left: 10px;
    width: 90%;
  }
  .color .disc {
    margin-left: 0;
    padding: 20px 0 8px 0;
    text-align: center;
  }
  .color-table-caption {
    top: -20%;
  }
  .color-table {
    margin: 0 calc(30% - 30vw);
    width: 88vw;
  }
  .color-table td {
    vertical-align: middle;
    padding: 20px 25px;
  }
  .color-table .text {
    font-size: 16px;
  }
  .color-table-title {
    font-size: 22px;
    padding-top: 10px;
  }
  .newline{
    display:none
  }
  .features-topic {
    display: block;
    margin: 2%;
    left: -10px;
    top: 400px;
  }
  .topic-1 {
    margin: 10px;
    padding: 10px;
    width: 355px;
    height: 145px;
    display:flex;
  }
  .features-topic img {
    max-width: 100px;
  }
  .topic {
    display:block;
    width: 260px;
    padding-top: 0px;
  }
  .topic-img{
    padding-top: 25px;
  }
  .corona {
    background: url("../assets/top-bus-corona.png");
    background-color: #FFF0F9;
    background-repeat: no-repeat;
    background-size: contain;
    min-height: 380px;
  }
  .corona-message .corona-title {
    font-size: 22px;
    line-height: 40px;
  }
  .corona-message .corona-caption {
    font-size: 11px;
    text-align: center;
    font-weight: bold;
  }
  .corona-message .title-box {
    top: 280px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .measures {
    margin-top: 25px;
  }
  .link {
    padding: 2% 4% 4% 4%;
    display: flex;
    flex-flow: column;
  }
  .box6 {
    border:2px solid #a6a6a6;
    padding:5px 14px;
    background:#FFF 0% 0% no-repeat padding-box;
    right:9px;
    bottom:27px;
    width:300px;
    min-width:170px;
    display:flex;
    justify-content:center;
    align-items:center;
    margin:10px 10px 10px 30px;
  }
  .contact-box {
    padding: 75px 10px 75px 10px;
  }
  .contact-box h1 {
    font-size: 38px;
  }
  .office-box {
    display: block;
    width: 100%;
  }
}
.contact {
  padding-top: 12px;
  padding-bottom: 12px;
}
.contact span {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Bus.vue